import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminCreateVotingScreen() {
    const { VideoVotingCreationScreen } = useModule(adminModuleQuery);
    return <VideoVotingCreationScreen />;
}
